var Header_announcement_bar_slider = document.querySelector('.Header_announcement_bar_slider');
if (Header_announcement_bar_slider) {
    new Swiper('.Header_announcement_bar_slider', {
        loop: true,
        grabCursor: true,
        spaceBetween: 0,
        slidesPerView: 1,
        watchSlidesProgress: true,
        draggable:!0,
        autoHeight:!1,
        watchOverflow:!0,
        threshold:10,
        mousewheel:{
            forceToAxis:!0
        },
        effect: "fade",
        speed: 300,
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        }
    })
}